import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
// ##### Komarov 2025-08-02
import { isEmptyObject } from '../../server/helpers/isArrayObject';
import { ValidateQuery } from '../Components/Pages/Helpers/helper';

// ##### 25-04-29 Komarov: Не шифруем параметры URL главной страницы и страниц, которые содержат в URL 'sitepages', 'mybooking', 'profile', 'city_overview' или 'hotel_overview'
const isCypherProtected = url =>
  url === '' ||
  url.includes('sitepages') ||
  url.includes('mybooking') ||
  url.includes('profile') ||
  url.includes('city_overview') ||
  url.includes('hotel_overview');

export default function (url) {
  // ##### Komarov 2025-08-02
  const shouldCypherUrlParams = useSelector(
    state => state.siteCypherCodeData.isDataEncrypted
  );
  const cypherKey = useSelector(
    state => state.siteCypherCodeData.description
  );
  if (url) {
    return ValidateQuery(
      url,
      !isCypherProtected(url) && shouldCypherUrlParams,
      cypherKey
    );
  }
  const location = useLocation();
  // ##### Komarov 2025-07-21
  const validatedQuery = ValidateQuery(
    location,
    !isCypherProtected(location.pathname) && shouldCypherUrlParams,
    cypherKey
  );
  return (!isEmptyObject(validatedQuery) && validatedQuery) || undefined;
}
